<div *transloco="let translate" class="auth-container">
  <div fxLayout="column" class="auth-content">
    <h1>
      {{ translate(TRANSLOCO_PREFIX + '.title') }}
    </h1>

    <form class="login-form" fxLayoutAlign="space-around" fxLayout="column" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
      @if (formError) {
        <div class="alert alert-danger">
          {{ errorMessage }}
        </div>
      }
      <div fxFlex="100" fxLayout="column">
        <h3>{{ translate(TRANSLOCO_PREFIX + '.text.emailSent') }}</h3>
        <div fxFlex="100" fxLayout="row wrap" fxLayoutAlign="space-around">
          <p-input-otp [length]="6" formControlName="code" name="topt"></p-input-otp>
        </div>
        <h3>
          {{ translate(TRANSLOCO_PREFIX + '.validation.newPassword') }}
        </h3>
        <eg-input
          formControlName="password"
          name="password"
          type="password"
          fieldType="M"
          class="mb-12"
          autocomplete="off"
          [label]="translate(TRANSLOCO_PREFIX + '.new')"
          [placeholder]="translate(TRANSLOCO_PREFIX + '.new')"
          [translationPrefix]="TRANSLOCO_PREFIX"
        >
        </eg-input>

        <eg-input
          formControlName="confirmPassword"
          name="confirmPassword"
          type="password"
          fieldType="M"
          class="mb-16"
          autocomplete="off"
          [label]="translate(TRANSLOCO_PREFIX + '.confirm')"
          [placeholder]="translate(TRANSLOCO_PREFIX + '.confirm')"
          [translationPrefix]="TRANSLOCO_PREFIX"
        >
        </eg-input>

        <div class="btn-container" fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
          <h6 class="btn-sidebar">
            @if (!counter) {
              <span>{{ translate('login.code.noCode') }}</span>
              <span class="link--basic" (click)="resendCode()">
                {{ translate('login.code.resendCode') }}
              </span>
            } @else {}
          </h6>
          <button egButton egButtonSize="large" type="submit" [disabled]="resetPasswordForm.invalid || disableActions()">
            {{ translate('login.btn.reset') }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
